import Icon from '../../components/icons/icon';
import { UserAddress } from '../../clients/quipli-service/user/user';
import { Typography } from '../../components/typography/typography';
import { formatPhoneNumber } from '../../util/util';

export const CheckoutSelectedAddress = ({ address }: { address?: UserAddress }) => {
  return address ? (
    <div className="grow flex flex-col gap-0.5 py-4 px-3">
      <Typography type="text-sm" weight="bold" className="text-grey-500">
        {address.name}
      </Typography>
      {address.companyName && (
        <Typography type="text-sm" className="text-grey-600">
          {address.companyName}
        </Typography>
      )}
      <div className="flex items-center gap-1">
        <Icon icon="Phone" stroke="var(--grey-600)" />
        <Typography type="text-sm" className="text-grey-600">
          {formatPhoneNumber(address.phone)}
        </Typography>
      </div>
      <div className="flex items-center gap-1">
        <Icon icon="Location01" stroke="var(--grey-600)" />
        <Typography type="text-sm" className="text-grey-600">
          {address.address1 != '-1' ? address.address1 : address.customDeliveryLocation || ''}
          {!address.isGoogleGenerated &&
            `${address.address2 ? `\n${address.address2}` : ''}${address.city ? `\n${address.city}` : ''}${
              address.state ? `, ${address.state}` : ''
            }${address.zip ? `\n ${address.zip}` : ''}`}
        </Typography>
      </div>
    </div>
  ) : null;
};
